<template>
  <div :class="$style.filter_tag_items">
    <template v-for="(item, index) in products" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="removeTag('products', index)">
        {{ getProductValue(item) }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="(item, index) in types" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="removeTag('types', index)">
        {{ getStoreTypeValue(item) }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="(item, index) in scales" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="removeTag('scales', index)">
        {{ getStoreScaleValue(item) }}
      </MoleculesConsumerTagButton>
    </template>
    <template v-for="(item, index) in othersSelects" :key="item.value">
      <MoleculesConsumerTagButton show-delete @on-delete="removeTag('othersSelects', index)">
        {{ getOthersSelectValue(item) }}
      </MoleculesConsumerTagButton>
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  FilterStoreType,
  StoreScaleType,
  StoreProductType,
  OthersSelectType,
} from "@tential/ec-gql-schema/master/store"

defineProps<{
  products: string[]
  types: string[]
  scales: string[]
  othersSelects: string[]
}>()

const getProductValue = (key: string) => {
  return StoreProductType[key as StoreProductType]
}

const getStoreTypeValue = (key: string) => {
  return FilterStoreType[key as FilterStoreType]
}

const getStoreScaleValue = (key: string) => {
  return StoreScaleType[key as StoreScaleType]
}

const getOthersSelectValue = (key: string) => {
  return OthersSelectType[key as OthersSelectType]
}

const emit = defineEmits<{
  (e: "removeTag", target: string, index: number): void
}>()

const removeTag = (target: string, index: number) => {
  emit("removeTag", target, index)
}
</script>

<style lang="scss" scoped module>
.filter_tag_items {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
